import { render } from "./SVGSeparatorRemove.vue?vue&type=template&id=a39992ba"
import script from "./SVGSeparatorRemove.vue?vue&type=script&lang=js"
export * from "./SVGSeparatorRemove.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe-test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__